import { type ReactElement } from 'react'
import { type WithCalendarEventId } from '@terros/common'
import { useRequiredParams } from '@util'
import { EditEventForm } from '../calendar/editEvent/EditEventForm'
import { createFileRoute } from '@tanstack/react-router'

function CalendarEvent(): ReactElement {
  const { eventId } = useRequiredParams<WithCalendarEventId>()
  return <EditEventForm eventId={eventId} />
}

export const Route = createFileRoute('/calendar/$eventId/')({
  component: CalendarEvent,
})
